
export class PageSupportModel {
    Telefono: string;
    OrariUfficio: Array<string>;
    LinkManuale: string;
    LinkCondizioni: string;
}